export enum ClinicalNotePreviewColors {
  TEXT = '#293D66',
  HEADER_TEXT = '#293D66',
}
